import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './front/pages/Blogs.css';
import App from './App';
import { GOOGLE_CLIENT_ID } from './helper/Constant';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from '../src/components/ScrollToTop'
import {HelmetProvider} from 'react-helmet-async';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <BrowserRouter>
       <ScrollToTop/>
       <HelmetProvider>
         <App />
       </HelmetProvider>
    </BrowserRouter>
  </GoogleOAuthProvider>
);
